import { Button, Card, Col, Divider, Image, Popconfirm, Row } from 'antd'
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import service from '../../../services/citizenscienceService';
import { recordError } from 'src/utils/logService';
import { BankOutlined, CheckCircleOutlined, CheckOutlined, ChromeOutlined, CloseCircleOutlined, EnvironmentOutlined, UserOutlined } from '@ant-design/icons';

import { PrivacyStatment } from '@seims/shared';
import './joinProject.css';

export default function ProjectDetailsMore() {

    const [joinProject, setJoinProject] = useState(false);
    const [projectDetails, setProjectDetails] = useState({});

    useEffect(() => {
        loadData();
    }, [])

    const { key } = useParams();
    let navigate = useNavigate();

    const handleNavigate = () => {
        navigate('/citisci')
    };
    const handleJoinProject = () => {
        setJoinProject(!joinProject)
    };
    const loadData = async () => {
        let uuid = key;
        try {
            if (key) {
                const response = await service.searchProjecttDetails(uuid);
                if (response && response.status === 200) {
                    const { data } = response;
                    setProjectDetails(data);
                } else {
                    setProjectDetails({})
                }
            }
        } catch (error) {
            recordError(error);
        }
    };

    return (
        <>

            {joinProject && (
                <div style={{paddingBottom:"30px"}}>
                    <PrivacyStatment />
                    <div className="t-and-c-buttons" style={{ textAlign: "center" }}>
                        <Button onClick={() => handleJoinProject()}>I do not accept</Button>

                        <Popconfirm
                            title="By clicking I accept you agree to the conditions stated in the privacy statement, proceed?"
                            onConfirm={() => navigate('/join-project', { state: { ...projectDetails, uuid: key } })}
                            onCancel={() => handleJoinProject()}
                            okText="Yes"
                            cancelText="No"
                        > &nbsp; &nbsp;
                            <Button type="primary" style={{ backgroundColor: "#FEEB9D" }}>I accept</Button>
                        </Popconfirm>
                    </div>
                </div>
            )}
            {!joinProject && (
                <div className='parent-div'>
                    <Row justify={"center"} >
                        <Col md={24} >
                            <div className="public-portal-section">
                                <h2> {projectDetails.name}</h2>
                            </div>
                        </Col>
                    </Row>
                    <div className='proj-description'>
                        <Row>
                            <Col md={24} >
                                <p style={{ fontSize: 20, marginBottom: "0px" }}><b>What is this project about?</b></p>
                                <div class="project-underline"></div>
                            </Col>
                        </Row>
                        <Row className="proj-description-text">
                            <Col md={18}><p>{projectDetails.description}</p>
                            </Col>
                            <Col className='proj-description-image' md={6}><Image /> </Col>
                        </Row>
                    </div>
                    <div className='proj-location'>
                        <Row>
                            <Col md={24}>
                                <p style={{ fontSize: 20, marginBottom: "0px" }}><b>What, Where and Who?</b></p>
                                <div class="project-underline"></div>
                            </Col>
                        </Row>
                        <Row justify="center">

                            <Col className='' sm={22} lg={10}><Image
                                src={require("../../../assets/questions.png")}
                                style={{ maxHeight: "241px", textAlign: "right", paddingBottom: "20px" }}
                                xs={24}
                                md={6}
                                alt="questions img"
                                preview={false}
                            />  <br /></Col>
                            <Col sm={22} lg={8} className="proj-info-list">
                                {projectDetails && projectDetails?.allowParticipation ? <><Image
                                    src={require("../../../assets/approval-icon.png")}
                                    alt="Accepting Application Icon"
                                    preview={false}
                                /> &nbsp; Accepting applications</> : <>
                                    <Image
                                        src={require("../../../assets/cancel-icon.png")}
                                        alt="Not Accepting Application Icon"
                                        preview={false}
                                    />&nbsp; Not Accepting applications</>}<br /><br />
                                <span className="location-icon">
                                    <Image
                                        src={require("../../../assets/location-icon.png")}
                                        alt="Not Accepting Application Icon"
                                        preview={false}
                                    />
                                </span> <div className="location">{projectDetails.locations?.map(loc => loc.town?.value + ", " + loc.province?.value)}<br /><br /></div>
                                <span className="location-icon domain-icon"> <Image
                                    src={require("../../../assets/shutter-icon.png")}
                                    alt="Not Accepting Application Icon"
                                    preview={false}
                                /> </span> <div className="location"> {projectDetails.domains?.map(dom => dom.value).join(" , ")}<br /><br /></div>
                                <div ></div>
                                <span><Image
                                    src={require("../../../assets/icon-building.png")}
                                    alt="Not Accepting Application Icon"
                                    preview={false}
                                /></span> &nbsp; {projectDetails.organisations}  <br />                         <br />
                                <span><Image
                                    src={require("../../../assets/icon-person.png")}
                                    alt="Not Accepting Application Icon"
                                    preview={false}
                                /></span> &nbsp; {projectDetails?.projectLead?.firstName + " " + projectDetails?.projectLead?.lastname}
                            </Col>
                        </Row>
                    </div>
                    <div className='proj-roles' >
                        <Row >
                            <Col md={14} >
                                <p style={{ fontSize: 20, marginBottom: "0px" }} ><b>What we need help with?</b></p>
                                <div class="project-underline"></div>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}></Col>
                            <Col md={6}>
                                {projectDetails.participantRoles?.map((part, index) =>
                                    <p><CheckOutlined style={{ fontSize: '16px' }} key={index} /> {part.value}</p>
                                )}
                            </Col>
                            <Col md={10} ><Image
                                src={require("../../../assets/need-help.png")}
                                style={{ maxHeight: "241px", textAlign: "right", paddingBottom: "20px" }}
                                xs={24}
                                md={6}
                                alt="questions img"
                                preview={false}
                            /> </Col>
                        </Row>
                        <Row justify="center">
                            <Button
                                style={{ marginLeft: "20px", borderRadius: "15px" }}
                                key="3c"
                                type="defaut"
                                className="right-align-button"
                                onClick={handleNavigate}
                            >
                                Back
                            </Button>
                            {projectDetails?.allowParticipation && (

                                <Button
                                    style={{ marginLeft: "20px", borderRadius: "15px", backgroundColor: "#FEEB9D" }}
                                    key="3b"
                                    // type="primary"
                                    className="right-align-button"
                                    onClick={handleJoinProject}
                                >
                                    Request to join
                                </Button>
                            )}
                        </Row>
                    </div>
                </div >

            )}

        </>
    )
}
